import { setColor, Color } from 'app_previous/styles/colors';
import { layout } from 'app_previous/styles/layout';
import styled, { css } from 'styled-components';

interface TableCellProps {
  backgroundColor: Color;
  borderColor: Color;
}

export const ContentGrid = styled.span`
  display: grid;
  row-gap: 4px;
  height: 100%;

  @media all and (max-width: ${layout.md}) {
    row-gap: 8px;
  }
`;

export const cellStyles = css<TableCellProps>`
  background-color: ${({ backgroundColor }) => setColor(backgroundColor)};
  padding: 1.5rem 2rem;
  border-right: 1px solid ${(props) => setColor(props.borderColor)};
  box-sizing: border-box;

  @media all and (max-width: ${layout.md}) {
    width: 100%;
    display: grid;
    border-left: 1px solid ${(props) => setColor(props.borderColor)};
  }

  @media all and (max-width: ${layout.sm}) {
    padding: 0.75rem 1rem;
  }
`;

export const EmptyCell = styled.td<TableCellProps>`
  ${cellStyles}

  @media all and (max-width: ${layout.md}) {
    display: none;
  }
`;

export const HeadCell = styled.th<TableCellProps>`
  ${cellStyles}

  text-transform: uppercase;
  align-items: center;

  @media all and (max-width: ${layout.md}) {
    padding: 1.5rem 1rem;
    border-left: none;

    &:last-child {
      border-right: none;
    }
  }
`;

export const TitleCell = styled.td<TableCellProps>`
  ${cellStyles}
  padding: 1.5rem 1rem;
  vertical-align: baseline;

  @media all and (max-width: ${layout.md}) {
    width: 100%;
    box-sizing: border-box;
    border: 1px solid ${(props) => setColor(props.borderColor)};
    vertical-align: unset;
  }

  @media all and (max-width: ${layout.sm}) {
    padding: 1.5rem 1rem;
  }
`;

export const ContentCell = styled.td<TableCellProps>`
  ${cellStyles}
`;
